import React from "react";

interface RoleSelectCardProps {
    selectable: boolean;
    selected: boolean;
    onSelect?: () => void;
    title: string;
    isCompany: boolean;
    isMandate: boolean;
    canRegister: boolean;
    onRegister?: () => void;
}

export default function RoleSelectCard({ selectable, selected, onSelect, title, isCompany, isMandate, canRegister, onRegister }: RoleSelectCardProps) {
    
    const iconClass = selected ? 'icon__checkmark-rounded icon__checkmark-rounded--masked bg-primary' : isCompany ? 'icon__company' : 'icon__person';

    return (
        <div className={"d-flex flex-wrap justify-content-between u-fs-16 p-2 rounded" + (selectable ? ' cursor-pointer u-hover' : '') + (selected ? ' bg-light' : '')} onClick={onSelect}>
            <div className="d-flex">
                <i className={iconClass}></i>
                <div className="d-flex flex-column ml-2">
                    <strong className={canRegister ? 'text-gray-700' : ''}>{title}</strong>
                    <small className="text-gray-700">{ isMandate ? 'Volitatud' : isCompany ? 'Äriklient' : 'Eraklient' }</small>
                </div>
            </div>
            { canRegister ? <button className="btn btn-link u-fs-16 p-0 ml-4" onClick={onRegister}>+ Registreeri kliendiks</button> : null}
        </div>
    );
}